import React from 'react';
import { Handle, Position } from 'reactflow';
import { Smile } from 'lucide-react';
import './NodeStyles.css';

const PleasantNode = ({ id, data, selected }) => {
    const flavor = data.flavor || 'joke';
    const scope = data.scope || 'in_context';
    const length = data.length || 'one_line';

    const handleDoubleClick = (e) => {
        e.stopPropagation();
        // Open the node editor panel (same pattern as QuestionNode)
        try {
            window.dispatchEvent(new CustomEvent('graph-center-node', { detail: { nodeId: id } }));
        } catch (_) { }
    };

    return (
        <div
            className={`question-node pleasant-node ${selected ? 'selected' : ''}`}
            onDoubleClick={handleDoubleClick}
            title={data.wfTooltip || `Pleasant: ${flavor}`}
        >
            <Handle type="target" position={Position.Top} className="node-handle node-handle-top" />
            <div className="node-header pleasant-header">
                <div className="node-icon"><Smile size={14} strokeWidth={1.5} /></div>
                <div className="node-id">{data.id || id}</div>
                <span className="node-type-badge pleasant-badge">{flavor.toUpperCase()}</span>
            </div>
            <div className="node-content pleasant-content">
                <div className="pleasant-meta">{scope} · {length}</div>
            </div>
            <Handle type="source" position={Position.Bottom} className="node-handle node-handle-bottom" />
        </div>
    );
};

export default PleasantNode;
